export class stockDropdownData{
    unitId: number;
    saleOrderId:number;
    itemSubCategoryId:number;
    itemId:number;
    brandId:number;
    locationId?:number;
}